import { z } from 'zod';
import { PriceSchema } from '~entities/price/model/price.contracts';

export const BookingDetailItemSchema = z.object({
  roomCategoryId: z.number(),
  roomCategoryName: z.string(),
  ratePlanId: z.number(),
  packageGroupId: z.number().nullable().optional(),
  arrivalDay: z.string(),
  departureDay: z.string(),
  nights: z.number().int(),
  adults: z.number().int(),
  children: z.array(z.number().int()),
  price: PriceSchema,
});

export const BookingDetailSchema = z.object({
  bookingId: z.string(),
  status: z.string(),
  salutation: z.string(),
  title: z.string().nullable().optional(),
  firstname: z.string(),
  lastname: z.string(),
  email: z.string(),
  phone: z.string().nullable().optional(),
  total: PriceSchema,
  depositAmount: PriceSchema,
  comment: z.string().nullable().optional(),
  bookedAt: z.string(),
  items: z.array(BookingDetailItemSchema),
});
